module.exports = __webpack_public_path__ + "static/ministry-c52a474ea8f2bfe8ef9302ceed937043.jpg";